import { apiClient } from "../lib/api-client";
import type { FeedbackInput } from "../features/feedback/FeedbackDialog";
import { getCurrentHostLocale } from "../i18n";

export const submitFeedback = async (input: FeedbackInput) => {
  const form = new FormData();
  form.append("type", input.type);
  form.append("subject", input.subject);
  form.append("description", input.description);
  const candidate = window.location.pathname.split("/")[2];
  const application =
    window.location.pathname.startsWith("/apps/") &&
    [
      "admin",
      "time-tracking",
      "human-resources",
      "invoice",
      "accounting",
    ].includes(candidate)
      ? candidate
      : "shell";
  form.append("application", application);
  form.append("locale", getCurrentHostLocale());
  if (input.screenshot) form.append("screenshot", input.screenshot);
  const { data } = await apiClient.post<{ reference: string }>(
    "/feedback",
    form,
  );
  return data;
};
